import api from '../utils/api';

// Actions
const SET_PRODUCTS = 'PRODUCTS/SET_PRODUCTS';
const ADD_PRODUCTS = 'PRODUCTS/ADD_PRODUCTS';
const SET_ERROR = 'PRODUCTS/SET_ERROR';
const SET_LOADING = 'PRODUCTS/SET_LOADING';

// Initial state for reducer
const initialState = {
    products: [],
    pageNumber: null,
    next: null,
    count: null,
    error: null,
    isLoading: false,
};

// Reducer(s)
export default function productsReducer(state = initialState, action) {
    switch (action.type) {
        case SET_PRODUCTS:
            return {
                ...state,
                products: action.response.results,
                pageNumber: action.response.pageNumber,
                next: action.response.next,
                count: action.response.count,
                error: null,
                isLoading: false,
            };
        case ADD_PRODUCTS:
            return {
                ...state,
                products: [...state.products, ...action.response.results],
                pageNumber: action.response.pageNumber,
                next: action.response.next,
                count: action.response.count,
                error: null,
                isLoading: false,
            };
        case SET_ERROR:
            return {...state, error: action.error, isLoading: false};
        case SET_LOADING:
            return {...state, isLoading: action.isLoading};
        default:
            return state;
    }
}

// Action creators
const setProducts = response => ({type: SET_PRODUCTS, response});
const addProducts = response => ({type: ADD_PRODUCTS, response});
const setError = error => ({type: SET_ERROR, error});
const setLoading = isLoading => ({type: SET_LOADING, isLoading});

const fetchProducts = (currentPageNumber, action, dispatch) => {
    dispatch(setLoading(true));
    api.productionProductList.fetch(null, {page: currentPageNumber}).then(
        data => dispatch(action({...data, pageNumber: (currentPageNumber + 1)})),
        (error) => {
            let message = gettext("Loading products failed");
            if (error.statusCode === 403) {
                try {
                    message = JSON.parse(error.responseText).detail;
                } catch (e) {
                    // Display the default message
                }
            }
            dispatch(setError(message));
        },
    );
};

export const fetchMoreProducts = () => (dispatch, getState) => {
    const currentPageNumber = getState().products.pageNumber || 1;
    fetchProducts(currentPageNumber, addProducts, dispatch);
};

export const refreshProducts = () => (dispatch) => {
    fetchProducts(1, setProducts, dispatch);
};



// WEBPACK FOOTER //
// ./src/ducks/products.js